export default __webpack_public_path__ + "static/media/big-cleaning.6f3bba57.jpeg";